<template>
  <v-dialog v-model="visible" persistent width="80%" max-width="700px">
    <v-card class="pa-8 tcdc-floor-modal-green-border">
      <div class="d-flex flex-1 justify-space-between mb-3">
        <span class="text-tcdc-green bold sub-header2">
          {{ data.floor ? data.floor.floor_name : '' }}
        </span>
        <v-btn icon @click="onClose">
          <v-icon color="#2e8037">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-layout justify-space-between class="tcdc-card-min-height" :column="$vuetify.breakpoint.xs" style="padding-bottom: 50px;">
        <v-flex xs6 d-flex align-center px-1 v-if="data.slide_images && data.slide_images.length > 0">
          <v-img eager max-height="100%" width="100%" :src="data.slide_images[0].slide_image"></v-img>
        </v-flex>
        <v-flex xs6 pl-5 pr-3 py-10>
          <p class="text-tcdc-green bold sub-header2">{{data[`name_${lang}`]}}</p>
          <div class="vhtml" v-html="data[`description_${lang}`]"></div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import { url } from "../../util/Constants";
import { mapState } from "vuex";

export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      default: () => ({})
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  },
  data: () => ({
    http: url
  }),
  methods: {
    onClose() {
      this.$emit("onClose");
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-floor-modal-green-border {
  border: 2px solid $tcdcGreen;
}
.tcdc-card-min-height {
  height: 400px;
}
</style>
